/**
 * Scripts Entry Point
 *
 * ブラウザコンソールから実行可能なスクリプト
 */

import seedDashboardData from './seedDashboardData';

// グローバルオブジェクトに登録
if (typeof window !== 'undefined') {
  (window as any).SalonHubScripts = {
    seedDashboardData,
  };

  console.log('🚀 SalonHub Scripts loaded!');
  console.log('');
  console.log('📦 利用可能なスクリプト:');
  console.log('  SalonHubScripts.seedDashboardData()       // ダッシュボードデータ投入');
  console.log('  SalonHubScripts.seedDashboardData(true)   // 既存データを上書き');
  console.log('');
}

export { seedDashboardData };
